module.exports = __webpack_public_path__ + "static/media/morphee-scrn.926357f3.jpg";